import { z } from 'zod'
import { ExclusiveOfferLegacyType } from '~library/enums'
import { dateValueSchema } from '~library/models'

/** 取得會員尊享清單資料 */
export const exclusiveOfferLegacyListDataSchema = z.object({
  /** 會員尊享Id */
  id: z.string(),
  /** 分類 */
  type: z.array(z.enum(ExclusiveOfferLegacyType)),
  /** 航點 */
  airportCode: z.array(z.string()),
  /** 檔案Guid */
  fileGuid: z.string(),
  /** 標題 */
  subject: z.string(),
  /** 內容 */
  content: z.string(),
  /** 新商品 */
  newTag: z.boolean(),
  /** 限時 */
  flashSale: z.boolean(),
  /** 限量 */
  limitedEdition: z.boolean(),
  /** 活動起始日期 */
  activityStartTime: dateValueSchema,
  /** 活動截止日期 */
  activityEndTime: dateValueSchema
})

export interface ExclusiveLegacyOfferListData extends z.infer<
  typeof exclusiveOfferLegacyListDataSchema
> {}
